import React from 'react';
import {View, StyleSheet} from 'react-native';
import AVText from 'src/components/elements/AVText';
import {getDescriber} from 'src/components/elements/descriptor/DescriptorType';
import Styles from 'src/components/Styles';
import EmptyReceipt from 'src/components/img/EmptyReceipt';
import Localized from 'src/constants/AppStrings';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

type EmptyReceiptComponentProps = {
  onExplorePress: () => void;
  onOffersPress: () => void;
  showOffers?: boolean;
};

const desc = getDescriber().historyListStyleDescriptor();

const combinedSpacing = Styles.Spacing.m3 + Styles.Spacing.m2;

const EmptyReceiptComponent = React.memo<EmptyReceiptComponentProps>(
  ({onExplorePress, onOffersPress, showOffers}) => {
    return (
      <View style={styles.container}>
        <EmptyReceipt />
        <AVText
          accessible
          style={styles.noReceiptsTxt}
          accessibilityLabel={Localized.Labels.no_receipts}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
        >
          {Localized.Labels.no_receipts}
        </AVText>
        <AVText
          accessible
          style={styles.firstPurchaseTxt}
          accessibilityLabel={Localized.Labels.make_your_first_purchase}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
        >
          {Localized.Labels.make_your_first_purchase}
        </AVText>
        <View accessible style={styles.btnView}>
          <RoundedAppButton
            buttonType={RoundedAppButtonType.Solid}
            titleText={Localized.Buttons.explore_and_shop}
            buttonContainerStyle={styles.exploreBtnContainer}
            buttonViewStyle={styles.exploreBtnView}
            accessibilityHintValue={'button'}
            aria-label={Localized.Buttons.explore_and_shop}
            textStyle={styles.btnText}
            onPress={onExplorePress}
          />
          {showOffers && (
            <RoundedAppButton
              buttonType={RoundedAppButtonType.Outline}
              titleText={Localized.Buttons.discover_offers}
              buttonContainerStyle={styles.offersBtnContainer}
              buttonViewStyle={styles.offersBtnView}
              accessibilityHintValue={'button'}
              aria-label={Localized.Buttons.discover_offers}
              textStyle={styles.btnText}
              onPress={onOffersPress}
            />
          )}
        </View>
      </View>
    );
  },
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: combinedSpacing,
  },
  noReceiptsTxt: {
    fontSize: getLayoutDescriber().subHeaderFontSize(),
    color: Styles.Colors.PayNew.black01,
    fontWeight: '700',
    marginTop: combinedSpacing,
    ...desc?.historyTabFontFamily,
  },
  firstPurchaseTxt: {
    fontSize: getLayoutDescriber().bodyFontSize(),
    color: Styles.Colors.PayNew.black01,
    fontWeight: '400',
    textAlign: 'center',
    marginTop: Styles.Spacing.m2,
    ...desc?.historyTabFontFamily,
  },
  btnView: {
    marginTop: combinedSpacing,
    alignSelf: 'center',
    marginHorizontal: Styles.Spacing.m3,
    width: '100%',
  },
  exploreBtnContainer: {
    marginBottom: Styles.Spacing.m2,
    width: '100%',
  },
  offersBtnContainer: {
    width: '100%',
  },
  exploreBtnView: {
    height: Styles.Heights.touchTargetHeight1 - 2,
    paddingHorizontal: combinedSpacing,
    width: '100%',
  },
  offersBtnView: {
    height: Styles.Heights.touchTargetHeight1 - 2,
    paddingHorizontal: combinedSpacing,
    width: '100%',
    borderWidth: 2,
    backgroundColor: Styles.Colors.PayNew.white01,
  },
  btnText: {
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '700',
    ...desc?.historyTabFontFamily,
  },
});

export default EmptyReceiptComponent;
